import DocumentInfoSection from './DocumentInfoSection';
import JumpButtonGroup from './JumpButtonGroup';
import ZoomControls from './ZoomControls';
import PageNavigation from './PageNavigation';
import PdfSearchPanel from '../../PdfSearchPanel';

/**
 * ツールバーコンポーネント
 * 保険会社情報、ジャンプボタン、ズームコントロール、ページナビゲーションを統合
 */
const Toolbar = ({
  // DocumentInfoSection props
  documentInfo,
  isMobile,
  isDocInfoAccordionOpen,
  onToggleDocInfoAccordion,

  // JumpButtonGroup props
  activeJumpButton,
  canJumpDisease,
  canJumpContents,
  canJumpLegend,
  canJumpAppendix,
  onJumpCurrentDisease,
  onJumpContents,
  onJumpLegend,
  onJumpAppendix,

  // ZoomControls props
  zoomLevel,
  onZoomIn,
  onZoomOut,

  // PageNavigation props
  currentPage,
  totalPages,
  isRendering,
  onPrevPage,
  onNextPage,
  onChangePageInput,
  onPageInputBlur,

  // キーワード検索 props
  searchText,
  onSearchTextChange,
  searchResults,
  currentSearchIndex,
  isSearching,
  isSearchOpen,
  onToggleSearchOpen,
  onSearch,
  onNextSearchResult,
  onPrevSearchResult,
  onClearSearch,
  pdfDocument,
  searchError,

  // 閉じるボタン
  onClose,
}) => {

  // キーワード検索コントロールに渡すprops
  const controlProps = {
    searchText,
    onSearchTextChange,
    searchResults,
    currentSearchIndex,
    isSearching,
    onSearch,
    onNextSearchResult,
    onPrevSearchResult,
    onClearSearch,
    pdfDocument,
    isMobile,
    searchError,
  };

  return (
    <>
      <div className="pdf-toolbar">
        {/* 保険会社名表示 */}
        <div className="pdf-control-group doc-info-toolbar">
          <DocumentInfoSection
            documentInfo={documentInfo}
            isMobile={isMobile}
            isDocInfoAccordionOpen={isDocInfoAccordionOpen}
            onToggleDocInfoAccordion={onToggleDocInfoAccordion}
          />
        </div>

        {/* 右側コントロール群（ズーム・ページャー・検索・閉じる） */}
        <div className="pdf-toolbar-controls">
          {/* ズームコントロール */}
          <ZoomControls
            zoomLevel={zoomLevel}
            onZoomIn={onZoomIn}
            onZoomOut={onZoomOut}
          />

          {/* ページナビゲーション */}
          <PageNavigation
            currentPage={currentPage}
            totalPages={totalPages}
            isRendering={isRendering}
            onPrevPage={onPrevPage}
            onNextPage={onNextPage}
            onChangePageInput={onChangePageInput}
            onPageInputBlur={onPageInputBlur}
          />

          {/* PCレイアウト時: キーワード検索パネルを表示 */}
          {!isMobile && (
            <div className="pdf-search-toolbar-panel">
              <PdfSearchPanel {...controlProps} />
            </div>
          )}
          {/* モバイルレイアウト時: キーワード検索ボタン表示 */}
          {isMobile && (
            <PdfSearchPanel.Trigger
              isSearchOpen={isSearchOpen}
              onToggleSearchOpen={onToggleSearchOpen}
            />
          )}

          {/* 閉じるボタン */}
          <button onClick={onClose} className="detail-close-button" title="閉じる">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>

      {/* モバイルレイアウト時: キーワード検索パネルをアコーディオン表示（ツールバー直下） */}
      {isMobile && (
        <div className={`pdf-search-accordion ${isSearchOpen ? 'open' : ''}`}>
          <div className="pdf-search-accordion-inner">
            <PdfSearchPanel {...controlProps} />
          </div>
        </div>
      )}

      {/* 該当疾病/目次/凡例/別表ボタンバー */}
      <div className="pdf-jump-bar">
        <JumpButtonGroup
          activeJumpButton={activeJumpButton}
          canJumpDisease={canJumpDisease}
          canJumpContents={canJumpContents}
          canJumpLegend={canJumpLegend}
          canJumpAppendix={canJumpAppendix}
          onJumpCurrentDisease={onJumpCurrentDisease}
          onJumpContents={onJumpContents}
          onJumpLegend={onJumpLegend}
          onJumpAppendix={onJumpAppendix}
        />
      </div>
    </>
  );
};

export default Toolbar;
